import React from 'react'
import SystemMessage from './EnterScreen/SystemMessage'
import { Helmet } from 'react-helmet';

const EnterScreen = ({ isLaunched, setIsLaunched }) => {
    return (
        <>
            <Helmet>
                <title>We Are A Site — Custom Websites for Small Businesses</title>
                <meta name="description" content="We Are A Site builds modern, powerful websites for small businesses—no coding needed. Let’s get your business online today." />
            </Helmet>
            <div className='EnterScreen full-height'>
                <SystemMessage isLaunched={isLaunched} setIsLaunched={setIsLaunched} />
            </div>
        </>

    )
}

export default EnterScreen